<template>
  <div class="form-check form-switch form-switch-lg">
    <input
      :id="id"
      :checked="value"
      type="checkbox"
      class="form-check-input"
      :disabled="disabled"
      role="switch"
      @input="$emit('input', $event.target.checked)"
    />
    <label class="form-check-label" :for="id"></label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
